<app-header-user></app-header-user>
<section class="account-page mrgn-top greybg py-5">
<div class="container">
  <div class="">

  <div class="row mt-2 mt-md-0"> 

      <aside class="col-sm-6 col-md-4 col-lg-3">
        <app-userdashboard-sidebar>  </app-userdashboard-sidebar>  
      </aside>
      <div class="col-sm-6 col-md-8 col-lg-9 mt-3 mt-md-0 rside-text">
        <app-userheading-section></app-userheading-section>
        <div *ngIf="isLoading">
        
          <div class="my-accountload text-center"> 
            <span class="lodercont">
              <app-refreshloader> </app-refreshloader>
            </span>
          </div>
        </div>
        <div class="row" *ngIf="wishList; else emptyList">
         <div class="col-md-12 pr-md-4">
            <div class="card shopping-card">
               <div class="table-responsive">
                  <table class="table" id="cart">
                     
                     <tbody>
                        <tr class="align-items-center my-4" *ngFor="let wl of wishList index as i">
                           <td data-th="Product">
                              <div class="row">
                                 <div class="col-sm-2 col-4 hidden-xs">
                                    <a routerLink="../../product/{{wl.cslug}}/{{wl.pSlug}}">
                                    <img src="{{imgurl}}{{wl.pImage}}" alt="Product 1" width="" class="img-fluid w-100 img-thumbnail"></a>
                                 </div>
                                 <div class="col-sm-10 col-8">
                                    <h4 class="nomargin">
                                      <a routerLink="../../product/{{wl.cslug}}/{{wl.pSlug}}">
                                      <span *ngIf="showLang == 'en' ">{{wl.pName}}</span>   
                                      <span *ngIf="showLang == 'ar' ">{{wl.pName_ar}}</span>
                                       
                                    </a>  
                                    </h4>
                                    <p *ngIf="showLang == 'en' ">{{wl.pdescription}}</p>
                                    <p *ngIf="showLang == 'ar' ">{{wl.pdescription_ar}}</p>
                                    <span class="prodprice"> AED {{wl.price}} </span>
                                 </div>
                              </div>
                           </td>
  
                           <td class="actions" >
                              <button class="btn btn-danger del-btn btn-sm" (click)="removeWishlist(wl.id)" >
                                 <i class="fas fa-trash-alt" aria-hidden="true"></i>
                                 <!-- <span *ngIf="isLoading">
                                   <i class="fas fa-circle-notch fa-spin"></i>
                                 </span> -->
                                </button> 
                            </td>
  
                        </tr>
                     </tbody>
                     <tfoot>
                     </tfoot>
                  </table>
               </div>
            </div>
         </div>
      </div>

      <ng-template #emptyList>
         <div class="text-center alert alert-success"> Your favorite list is empty &nbsp; <a class="alert-link" [routerLink]="['/order-online']">Go to Product Page</a></div> 
      </ng-template>


    </div>
      </div>
   </div>
   </div>
</section>

